import React from "react";
import { compressNumber } from "../../helpers";

interface SliderThumbProps {
    props: any;
    index: number;
    values: number[];
    selCurrency: string;
    sliderKey: string;
}

export const SliderThumb: React.FC<SliderThumbProps> = ({ props, index, values, selCurrency, sliderKey }) => (
    <div
        {...props}
        key={props.key}
        style={{
            ...props.style,
            height: "20px",
            width: '20px',
            borderRadius: "50%",
            backgroundColor: 'rgba(219, 219, 219, 1)',
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.25)',
            border: '1px solid rgba(255, 255, 255, 1)'
        }}
    >
        <div
            className="slider-thumb-label"
            style={{
                position: "absolute",
                top: "-28px",
                left: "50%",
                transform: "translateX(-50%)",
                color: "#fff",
                fontSize: "12px",
                fontFamily: `"Poppins-Regular", sans-serif`,
                whiteSpace: "nowrap", 
                padding: "4px",
                borderRadius: "4px",
                backgroundColor: 'rgba(77, 77, 77, 1)',
            }}
        >
            {selCurrency == "USD"
                ? compressNumber(values[index], selCurrency, false, true, true, sliderKey === "core_transaction_value")
                : compressNumber(values[index], selCurrency, false, true, true, sliderKey === "core_transaction_value")}
            <span
                style={{
                    position: "absolute",
                    left: "50%",
                    bottom: "-12%",
                    transform: "translateX(-50%)",
                    width: 0,
                    height: 0,
                    borderLeft: "5px solid transparent",
                    borderRight: "5px solid transparent",
                    borderTop: "5px solid rgba(77, 77, 77, 1)",
                }}
            />
        </div>
    </div>
);